var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.333 2.667h-3.479l-.22-.877A2.362 2.362 0 009.344 0H6.657c-1.084 0-2.03.738-2.292 1.79l-.219.877H.667A.667.667 0 00.667 4h.702l.562 10.11A2 2 0 003.93 16h8.142a2 2 0 001.998-1.89L14.631 4h.702a.667.667 0 100-1.333zM5.66 2.113a1.03 1.03 0 01.998-.78h2.686c.472 0 .884.322.998.78l.139.554H5.52l.139-.554zM13.295 4l-.557 10.036a.668.668 0 01-.667.63H3.93a.668.668 0 01-.667-.63L2.705 4h10.59zM5.333 5.333A.667.667 0 004.667 6v6.667a.667.667 0 101.333 0V6a.667.667 0 00-.667-.667zm2.667 0A.667.667 0 007.333 6v6.667a.667.667 0 101.334 0V6A.667.667 0 008 5.333zm2.667 0A.667.667 0 0010 6v6.667a.667.667 0 101.333 0V6a.667.667 0 00-.666-.667z",
    id: "delete_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "delete_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#delete_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#delete_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B596B",
    mask: "url(#delete_svg__b)",
    d: "M0 0h16v16H0z"
  }))));
}
export default __webpack_public_path__ + "img/2328d8d7c8532224e0b9057ca3620e32.svg";
export { SvgDelete as ReactComponent };